export class BaseActorModel {

  /** InviteId */
  public id!: string;/**
   * Document GUID
   */
  public documentId!: string;

  /**
   * Person GUID
   */
  public dossierPersonId!: string;



  /**
   * Name of the Actor
   * - FirstName+Prefix+LastName
   */
  public fullName!: string;

  /**
   * First name of the Actor
   */
  public firstname!: string;
  /**
   * Prefix name of the Actor
   */
  public prefix!: string;
  /**
   * Last name of the Actor
   */
  public lastname!: string;
  /**
   * shortened name for document viewing
   */
  public acronym!: string;
  /**
   * IF SIGN: needed for document viewing
   */
  public fieldName!: string;
  /**
   * Whether signing field should be displayed when viewing document
   */
  public hasSigned!: boolean;
  public sigFieldX!: any;
  public sigFieldY!: any;
  public sigFieldW!: any;
  public sigFieldH!: any;
  public sigFieldPage!: number;
  public order!: number;
  public action!: string | any;
  public allowedQtsps: string[] | null = null;
  public disableQtsps: boolean = false;
  /// <summary>
  /// True is the actor is an user at PKI
  /// </summary>
  public isCustomer: boolean = false;
  /// <summary>
  /// Value of 'signatureprovider' CLAIM if set
  /// </summary>
  public preferredSignatureProvider: string | null = null;
  /// <summary>
  /// Value of 'cscprovidername' CLAIM if set
  /// </summary>
  public preferredCscProvider: string | null = null;
}

export class DocumentActor extends BaseActorModel {
  public email!: string;
  public mobile!: string;
  public ordinal!: number;
  public signingDate!: Date | null;
  public deadline!: Date;
  public validateRealIdentity!: boolean;
  public identityProvider!: string;
  public language!: string;
  public actorId!: number;
  public warning!: boolean;
  public message!: string;

  public deadlineDays: number | null = null;
  public workflowPlaceholderId: number | null = null;
  public suggestedCreditCost: number = 0;

  public credits!: number;
  public grouped: boolean = false;
}

export class DocumentActorWithCheckboxes extends DocumentActor {
  checked?: boolean = false;
}